import { useEffect, useRef, useState } from "react";

import CobrancaQuebrada from "./cobrancaQuebrada";

import classNames from "classnames";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";

import { ConfirmDialogPague, DataTablePague } from "../../../../styles/primeReactConfig";
import { confirmFooter } from "../../../confirmFooter";

import { BiClipboard, BiLinkExternal } from "react-icons/bi";
import { BsExclamationTriangle, BsInfoCircle } from "react-icons/bs";
import { FaUndo } from "react-icons/fa";

import { Api } from "../../../../services/api";

import { format, parseISO } from "date-fns";
import { associado_id, userInfo } from "../../../../services/authHandlers";
import Base64ToPDF from "../../../../utils/Base64ToPDF";


export const NegotiationDetail = ({ rowInfo, close, toast }) => {
  const { cobranca_id, cobranca_tipo_pagamento } = rowInfo;
  const [loading, setLoading] = useState(true);
  const [boletos, setBoletos] = useState([]);
  const [cartao, setCartao] = useState([]);
  const [negociacoes, setNegociacoes] = useState([]);
  const [naoEncontrada, setNaoEncontrada] = useState(false);
  const [reload, setReload] = useState(true);
  const [mostraCobrancaPassadaDialog, setMostraCobrancaPassadaDialog] = useState(false);
  const cobranca_quebrada_id = useRef(null);

  useEffect(() => {
    consultaCobrancasNegociadas();
  }, [reload]);

  // chamada de api

  const atualizarBoleto = async (e) => {
    setLoading(true)
    try {
      const associado_operador_id = userInfo.associado_id || associado_id
      const { data } = await Api.post('boletos/recria', { cobranca_id: cobranca_id, boleto_id: e.boleto_id, associado_id: associado_operador_id, origem: 'App Cliente' });
      Base64ToPDF(data.boleto.boleto_base64, `boleto-novo-gerado-em-${format(new Date(), 'dd/MM/yyyy')}`);
      toast('success', 'Um novo boleto foi gerado com sucesso para esta parcela!')
    } catch (error) {
      console.log(error.response)
      toast('error', 'Erro ao gerar boleto!')
    } finally {
      setLoading(false)
      setReload(prevReload => !prevReload)
    }
  }

  const consultaCobrancasNegociadas = async () => {
    try {
      setLoading(true);
      const { data } = await Api.get(`/cobranca/consulta-cobrancas-negociadas/${cobranca_id}`);
      setNegociacoes(data.cobrancasNegociadas);
      setBoletos(data.boletos);
      setCartao(data.cartao);
    } catch (error) {
      console.error(error);
      if (!error.response)
        toast('error', 'Erro de conexão')
      if (error.response.status === 404) {
        setNaoEncontrada(true)
        toast('warn', 'Nenhuma negociação encontrada')
      }
    } finally {
      setLoading(false)
    }
  };

  // formatação

  const formatarValor = (value) => {
    return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const formatarData = (e) => {
    return (e && e !== '') ? format(parseISO(e), 'dd/MM/yyyy') : '-';
  };

  // template

  const headerCobrancas = (
    <div>
      <h5><b>Cobranças Negociadas</b></h5>
    </div>
  )
  const headerBoletos = (
    <div>
      <h5><b>Boletos</b></h5>
    </div>
  )
  const headerCartao = (
    <div>
      <h5><b>Cartão</b></h5>
    </div>
  )

  function link(rowData) {
    return (
      <section className="w-full flex justify-center">
        <Button
          onClick={() => Base64ToPDF(rowData.boleto_base64,
            `boleto-vencimento:${format(new Date(rowData.cobranca_data_vencimento), "dd/MM/yyyy")}.pdf`)}
          icon={<BiLinkExternal className="text-xl text-blue-600 dark:text-sky-400" />}
          text
        />
      </section>
    );
  }

  function copyCode(rowData) {
    // - verifica o codigo de barras das linhas para transformar em codigo de barras digitavel
    let boleto_barras_vazio = false
    let codigo_barras_digitavel = ''
    if (!rowData.boleto_coleto_barras) {
      boleto_barras_vazio = true
    }
    else if (rowData.boleto_coleto_barras.startsWith('756')) {
      // - boleto é sicoob (numero da agencia começa de 0 a 2 em indice);
      const codigo_barras_arr = rowData.boleto_coleto_barras.split('');

      const instituicao_dest_moeda = codigo_barras_arr.slice(0, 4);
      const id_negocio = codigo_barras_arr.slice(19, 20);
      const cod_agencia = codigo_barras_arr.slice(20, 24);

      const n_contrato_cob = codigo_barras_arr.slice(24, 33);
      const nosso_numero = codigo_barras_arr.slice(33, 42);
      const modalidade_boleto = codigo_barras_arr.slice(42, 44);

      const dv_codigo_barras = codigo_barras_arr.slice(4, 5);

      const fator_vencimento = codigo_barras_arr.slice(5, 9);
      const valor_nominal_boleto = codigo_barras_arr.slice(9, 19);

      //da direita pra esquerda, multiplicar alternando por 2 e 1 nessa ordem
      let arr_campo_1 = instituicao_dest_moeda.concat(id_negocio.concat(cod_agencia)).reverse();
      let arr_campo_2 = n_contrato_cob.concat(nosso_numero.shift()).reverse();
      let arr_campo_3 = nosso_numero.concat(modalidade_boleto).reverse();

      const arr_campos_formatar = [
        arr_campo_1,
        arr_campo_2,
        arr_campo_3
      ]

      arr_campos_formatar.forEach((campo_atual) => {
        const dv_campo = encontra_dv_boleto_barras(campo_atual);
        campo_atual.reverse().push(dv_campo);
        campo_atual.splice(5, 0, '.')
      })

      let arr_campo_5 = fator_vencimento.concat(valor_nominal_boleto)

      codigo_barras_digitavel = `${arr_campo_1.join('')} ${arr_campo_2.join('')} ${arr_campo_3.join('')} ${dv_codigo_barras.join('')} ${arr_campo_5.join('')}`
    }
    else if (rowData.boleto_coleto_barras.startsWith('450')) {
      const codigo_barras_arr = rowData.boleto_coleto_barras.split('');
      const arr_campo_1 = codigo_barras_arr.slice(0, 10);
      const arr_campo_2 = codigo_barras_arr.slice(10, 21);
      const arr_campo_3 = codigo_barras_arr.slice(21, 32);
      const arr_campo_4 = codigo_barras_arr.slice(32, 33).join('');
      const arr_campo_5 = codigo_barras_arr.slice(33, 47).join('');

      const arr_campos_formatar = [
        arr_campo_1,
        arr_campo_2,
        arr_campo_3
      ]

      arr_campos_formatar.forEach((campo_atual) => {
        campo_atual.splice(5, 0, '.')
      })

      codigo_barras_digitavel = `${arr_campo_1.join('')} ${arr_campo_2.join('')} ${arr_campo_3.join('')} ${arr_campo_4} ${arr_campo_5}`
    }

    function encontra_dv_boleto_barras(arr_campo) {
      let mult_digito = 2;
      const arr_mult_dv = arr_campo.map((digito) => {
        let resultado = digito * mult_digito;
        // alternancia de 2 e 1
        mult_digito = mult_digito === 2 ? 1 : 2;

        if (String(resultado).length > 1) {
          const resultado_arr = String(resultado).split('')
          resultado = Number(resultado_arr[0]) + Number(resultado_arr[1])
        }

        return resultado;
      });

      let soma_dv = 0;
      arr_mult_dv.forEach(digito => {
        soma_dv += digito
      });

      const digito_dv = 10 - (soma_dv % 10);
      return String(digito_dv);
    }


    return (
      <section className="w-full flex justify-center">
        <Button
          onClick={() => {
            navigator.clipboard.writeText(codigo_barras_digitavel);
            toast('info', 'Código de Barras copiado!');
          }}
          icon={<BiClipboard className="text-xl text-blue-600 dark:text-sky-400" />}
          text
          disabled={boleto_barras_vazio}
        />
      </section>
    )
  }

  function showDetailsQuebrada(rowData) {
    if (rowData.v_cobranca_descricao.startsWith("Saldo Remanescente"))
      return (
        <Button
          pt={{
            root: `hover:dark:bg-amber-200 hover:bg-yellow-500 
            dark:bg-amber-400 bg-yellow-300
            h-12 w-12 rounded-full 
            flex justify-center items-center
            text-white dark:text-black 
            transition duration-300`,
            label: "absolute",
          }}
          icon={<BsInfoCircle className="text-3xl text-black" />}
          onClick={() => { cobranca_quebrada_id.current = rowData.v_cobranca_id; setMostraCobrancaPassadaDialog(true) }}
        />
      )
    else
      return "-"
  }

  function novoBoletoBody(rowData) {
    return (
      <Button
        rounded
        severity="success"
        icon={<FaUndo />}
        onClick={() => { confirmUpdate(rowData) }}
        disabled={(rowData.boleto_status === 'Pago' || rowData.boleto_status === 'Cancelado')}
      />
    )
  }

  const confirmUpdate = (rowData) => {
    confirmDialog({
      message: 'Deseja emitir segunda via?',
      header: 'Emitir 2ª via',
      icon: <BsExclamationTriangle />,
      pt: ConfirmDialogPague,
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => atualizarBoleto(rowData),
      footer: (e) => confirmFooter(e)
    });
  }

  return (
    <Dialog
      header="Detalhes da Negociação"
      visible
      pt={{
        root: 'w-screen md:w-[70vw] max-h-[90vh] ',
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80'),
        content: ({ state }) => ({
          className: classNames('overflow-y-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
      onHide={() => close()}
    >
      <ConfirmDialog />
      {negociacoes.length > 0 && <div>
        <DataTable pt={DataTablePague} emptyMessage='Nenhuma cobrança negociada.' header={headerCobrancas} value={negociacoes} loading={loading}>
          <Column header="Nº Contrato" field="v_cobranca_numero_cliente_credor" />
          <Column header="Descrição" field="v_cobranca_descricao" />
          <Column header="Valor" body={(rowData) => formatarValor(rowData.v_cobranca_valor)} />
          <Column header="Vencimento" body={(rowData) => formatarData(rowData.v_data_vencimento_primeiro_boleto)} />
          <Column header="Detalhes" body={rowData => showDetailsQuebrada(rowData)} />
        </DataTable>
      </div>}
      {naoEncontrada && <h4 className="text-center font-bold">Nenhuma negociação encontrada</h4>}
      <br />
      {boletos.length > 0 &&
        (<div>
          <DataTable pt={DataTablePague} emptyMessage='Nem um boleto gerado.' header={headerBoletos} value={boletos} loading={loading}>
            <Column header="Vencimento" body={(rowData) => formatarData(rowData.cobranca_data_vencimento)} />
            <Column header="Valor" body={(rowData) => formatarValor(rowData.boleto_valor)} />
            <Column field="boleto_order" header="Parcela" />
            <Column header="Status" field="boleto_status" />
            <Column header="Data Pagamento" body={(rowData) => formatarData(rowData.boleto_data_pagamento)} />
            <Column header="Ver Boleto" body={link} />
            <Column header="Código de Barras" body={copyCode} />
            <Column header="Gerar Novo Boleto" body={rowData => novoBoletoBody(rowData)} />
          </DataTable>
        </div>)}
      <br />
      {cartao.length > 0 &&
        (<div>
          <DataTable pt={DataTablePague} emptyMessage='Nem um pagamento em cartão gerado.' header={headerCartao} value={cartao} loading={loading}>
            <Column body={(rowData) => formatarData(rowData.cartao_releasedate)} header="Data Pagamento" />
            <Column body={(rowData) => formatarValor(rowData.cartao_valor)} header="Valor" />
            <Column field="number_installments" header="Parcelas" />
            <Column field="cartao_type" header="Bandeira" />
          </DataTable>
        </div>)}
      {/* <Column body={rowData => formatCurrency(rowData.boleto_valor)} field="boleto_valor" header="Valor" />
          <Column
            body={statusPagamentoBoleto}
            header="Status de pagamento"
          />          
          <Column body={dataVencimento} header="Data de Vencimento" />
          <Column body={formatDatePayment} header="Pago em" />          
          <Column header="Ver Boleto" body={link} />
          <Column header="Gerar Novo Boleto" body={rowData=>novoBoletoBody(rowData)} /> */}
      {mostraCobrancaPassadaDialog && <CobrancaQuebrada close={() => setMostraCobrancaPassadaDialog(false)} cobranca_quebrada_id={cobranca_quebrada_id.current} />}
    </Dialog>
  )
}